import React from "react";
import {CForm} from "@coreui/react";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

const ARModalForm = (props) => {
  const {formId, children, validationSchema, defaultValues, onFormSubmit, ...otherProps} = props;

  const {handleSubmit, control} = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
    defaultValues
  });

  return (
    <CForm id={formId} onSubmit={handleSubmit(onFormSubmit)} {...otherProps}>
      {React.isValidElement(children) && React.cloneElement(children, {control})}
    </CForm>
  );
};

export default ARModalForm;